import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const PanelLeft: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { width: '18', height: '18', x: '3', y: '3', rx: '2', ry: '2' }],
    ['line', { x1: '9', x2: '9', y1: '3', y2: '21' }],
  ],
];

export default PanelLeft;
